module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "x-1-chapter-number-14"
  }), _vm._v(" "), _c('p', {
    staticClass: "x-2-ch-title-14"
  }, [_vm._v("Acknowledgments"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("\tWith gratitude to Texas Rangers Capt. Alvin A. Alexis II, Capt. Clete Buckaloo, Capt. Bob Bullock, Lt. Jeff Collins, Jeff Cook, Joe Haralson, Capt. Howard Duane “Dino” Henderson, Lt. Brooks Long, Frank J. Malinak, Capt. Shawn Palmer, Ronald Pettigrew, Ray Ramon, Capt. Jeffery Robertson, and Lt. George Turner. Also, my thanks to Rachel Barnett, research librarian, Texas Ranger Hall of Fame and Museum (TRHFM); Christina Stopka, "), _c('span', [_vm._v("deputy director, TRHFM; Christina Smith, research librarian, TRHFM; Jason Walker, director of research, Texas State Cemetery; Craig Reinhold; Chri"), _c('a', {
    attrs: {
      "id": "x.1886"
    }
  }, [_vm._v("stine Taylor-Butler; Nina Romberg; Cynthia Leal Massey; and Judith Keeling.")])])]), _c('a', {
    attrs: {
      "id": "x.1886"
    }
  })]), _c('a', {
    attrs: {
      "id": "x.1886"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5299718f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LONHeFM02.vue
// module id = 60
// module chunks = 0